import GoToPoDetails from 'src/components/GoToPoDetails';
import { GridColumn } from 'src/components/GridWrapper';
import CustomFilterCell from 'src/components/custom-cells/CustomFilterCell';
import VarianceCell from 'src/sections/variance/VarianceCell';
import { validateNumber } from '../variance_details/VarianceLineItemColumns';

export const varianceColumns: GridColumn<any>[] = [
  {
    field: 'poNum',
    title: 'PO #',
    filter: 'text',
    dataType: 'string',
    component: GoToPoDetails,
  },
  {
    field: 'varianceId',
    title: 'Variance #',
    filter: 'numeric',
    dataType: 'number',
    component: VarianceCell,
    columnMenu: CustomFilterCell,
    filterFormat: '#',
    step: 1,
  },
  {
    field: 'supplierName',
    title: 'Supplier Name',
    filter: 'text',
    dataType: 'string',
  },
  {
    field: 'varianceQuantity',
    title: 'Qty var',
    filter: 'numeric',
    dataType: 'fixed',
    specificStyle: validateNumber,
    filterFormat: '#',
    step: 1,
  },
  {
    field: 'varianceQuantityPercentage',
    title: 'Qty var %',
    filter: 'numeric',
    format: '{0:n2}%',
    dataType: 'fixed',
    specificStyle: validateNumber,
    filterFormat: 'p2',
    step: 0.01,
  },
  {
    field: 'varianceDollar',
    title: '$ Var',
    filter: 'numeric',
    format: '{0:c2}',
    dataType: 'fixed',
    specificStyle: validateNumber,
    filterFormat: 'c2',
  },
  {
    field: 'varianceDollarPercentage',
    title: '$ Var %',
    filter: 'numeric',
    format: '{0:n2}%',
    dataType: 'fixed',
    specificStyle: validateNumber,
    filterFormat: 'p2',
    step: 0.01,
  },
  {
    field: 'poDate',
    title: 'PO Date',
    filter: 'date',
    format: '{0:MM/dd/yyyy}',
    dataType: 'date',
  },
  {
    field: 'poSubject',
    title: 'PO Subject',
    filter: 'text',
    dataType: 'string',
  },
  {
    field: 'buyerCompany',
    title: 'Company',
    filter: 'text',
    dataType: 'string',
  },
  {
    field: 'buyerName',
    title: 'Buyer',
    filter: 'text',
    dataType: 'string',
  },
];
